import script from "./Side.vue?vue&type=script&setup=true&lang=js"
export * from "./Side.vue?vue&type=script&setup=true&lang=js"

import "./Side.vue?vue&type=style&index=0&id=4879a064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4879a064"]])

export default __exports__